import React, { useEffect, useState } from "react"
import { Button, Card, CardBody, CardText, CardTitle, FormGroup, Input, Spinner, Table, Modal, ModalHeader, ModalBody, ModalFooter } from "reactstrap"

import { useWallet } from "../../libs/useMetaMaskWallet"
import Web3 from "web3"
import { ethers } from "ethers"
import { Provider, utils, Wallet, Web3Provider } from "zksync-web3"
import erc20Abi from "../../abi/MyERC20.json"
import nftAbi from "../../abi/BaseRoyaltyCappedNFTFC.json"
import ConnectWallet from "../../Components/ConnectWallet"
import BreadCrumb from "../../Components/BreadCrumb"
import { formatNumber, avgGasPrice } from "../../utils"
import { useToast } from "../../hooks/toast"

const parts = window.location.hostname.split(".") // ['swordsofblood', 'idexo', 'com'], ['localhost'], or ['app', 'idexo', 'io']
const subdomain = parts[0]

const nftContract = "0x389C769883dECa0743fdF63c0CAf40787036b138" //zk companions
const admin = "0x8142409931f554d99013de129cdDc70EA016d62d"
const mintPass = "0x2BC96F27618Da97A0113afA8EC1d6d36dA24887F" //contract to check if they have to validate entry
const erc20zkc = "0x4a248ef75c909B990F251a02D8F9eB4E26C329Fa"
const erc20Paymaster = "0xbbDF698Cc1B86D5AF67Ba674aC3fEa7E668C32c6"
const erc721Paymaster = "0x5396C3151F54D907E4743996C499621Bb403A1AE"

const companions = {
    victor: "https://arweave.net/Vk5SdkVLUrO3KtA3Rt2CuAWv-lwufRXORGNo4_ZHHtI",
    alyssa: "https://arweave.net/yp0rfd6BhG5OlzS6uU3Ssi52_Hzyj6GfShHtnLeAbF0",
    fae: "https://arweave.net/orAdnp0Sdjj9kWD0RGUPdRelnW-0CV8zIIs-sL4rZtE"
}

const erc20PaymasterParams = utils.getPaymasterParams(erc20Paymaster, {
    type: "ApprovalBased",
    token: erc20zkc,
    minimalAllowance: ethers.BigNumber.from(5),
    innerInput: new Uint8Array()
})

const paymasterParams = utils.getPaymasterParams(erc721Paymaster, {
    type: "General",
    innerInput: new Uint8Array()
})

// async function mintViaPaymaster() {
//     const gasPrice = await provider.getGasPrice()
//     console.log(gasPrice)
//     const theWallet = new Wallet(privateKey, provider)
//     const erc20 = new ethers.Contract(erc20zkc, tabi, theWallet)
//     const gasLimit = await erc20.estimateGas.mint(admin, 5, { //minting 5 tokens to the admin address
//         customData: {
//             gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
//             paymasterParams: paymasterParams
//         }
//     })
//     const fee = gasPrice.mul(gasLimit.toString())
//     console.log("Transaction fee estimation is :>> ", fee.toString())
//     await (
//     await erc20.mint(admin, 5, { //so you instantiate the target contract and add paymaster params and bootloader knows how to handle this
//       // paymaster info

//           customData: {
//             paymasterParams: paymasterParams,
//             gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
//           },

//     })
//   ).wait()
// }

// async function mintViaPaymaster721() {
//     const gasPrice = await provider.getGasPrice()
//     console.log(gasPrice)
//     const theWallet = new Wallet(privateKey, provider)
//     const erc20 = new ethers.Contract(erc20zkc, tabi, theWallet)
//     const gasLimit = await erc20.estimateGas.mint(admin, 5, { //minting 5 tokens to the admin address
//         customData: {
//             gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
//             paymasterParams: paymasterParams
//         }
//     })
//     const fee = gasPrice.mul(gasLimit.toString())
//     console.log("Transaction fee estimation is :>> ", fee.toString())
//     let mintAmount = ethers.utils.parseEther("5000000000000000000")
//     await (
//     await erc20.mint(admin, mintAmount, { //so you instantiate the target contract and add paymaster params and bootloader knows how to handle this
//       // paymaster info

//           customData: {
//             paymasterParams: paymasterParams,
//             gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
//           },

//     })
//   ).wait()
// }

// async function mintNFT(account, tokenUri) {
//     let senderAddress = '0x8142409931f554d99013de129cdDc70EA016d62d'
//     let gas = 8000000
//     let maxFeePerGas = 250000000
//     let maxPriorityFeePerGas = 250000000
//     Web3.providers.HttpProvider.prototype.sendAsync = Web3.providers.HttpProvider.prototype.send
//     const web3Provider = new HDWalletProvider(mnemonic, new Web3.providers.HttpProvider(zkTestRPC), 0, 10) // 1 replace 0, 10
//     const web3 = new Web3(web3Provider)
//     let tokenContract = new web3.eth.Contract(yoabi, nftContract)
//     let data = tokenContract.methods.mintNFT(account, tokenUri).encodeABI()
//         const tx = {
//             from: senderAddress,
//             to: nftContract,
//             data: data,
//             gas: gas,
//             maxFeePerGas: maxFeePerGas,
//             maxPriorityFeePerGas: maxPriorityFeePerGas,
//             chainId: 280,
//         }
//         let transactionHash = await web3.eth.sendTransaction(tx)
//         return transactionHash
// }

const ZkCompanions = () => {
    const web3 = new Web3(window.ethereum)

    const [isLoading, setIsLoading] = useState(false)
    const [processingNFTMint, setProcessingNFTMint] = useState(false)
    const [processingTokenMint, setProcessingTokenMint] = useState(false)
    const [isConnectedToWallet, setIsConnectedToWallet] = useState(false)
    const [txModal, setTxModal] = useState(false)
    const [tx, setTx] = useState({
        status: "",
        hash: ""
    })

    const handleTx = (status, hash) => {
        setTx({ status: status, hash: hash })
    }

    const handleTxModal = (type) => {
        switch (type) {
            case "open":
                setTxModal(true)
                break
            case "close":
                setTxModal(false)
                setTx("", "")
                break

            default:
                break
        }
    }

    const [chainId, setChainId] = useState(undefined)
    const [account, setAccount] = useState(0)

    const toast = useToast()
    const wallet = useWallet()

    const handleSubmitButton = async (action, type) => {
        switch (action) {
            case "mintNFT":
                await mintNFTFunction()

                break

            case "mintTokens":
                await mintTokensFunction()

                break

            default:
                break
        }
    }

    const mintTokensFunction = async () => {
        const provider = new Provider("https://testnet.era.zksync.dev")
        const signer = new Web3Provider(window.ethereum).getSigner()
        const gasPrice = await provider.getGasPrice()
        if (chainId === 280) {
            setProcessingTokenMint(true)
            try {
                const erc20contract = new ethers.Contract(erc20zkc, erc20Abi, signer)
                // const zkNFTcontract = new web3.eth.Contract(nftAbi, nftContract)
                const gasLimit = await erc20contract.estimateGas.mint(wallet.account, ethers.utils.parseEther("10"), {
                    //minting 5 tokens to the admin address
                    customData: {
                        gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
                        paymasterParams: erc20PaymasterParams
                    }
                })
                const fee = gasPrice.mul(gasLimit.toString())
                await (
                    await erc20contract.mint(wallet.account, ethers.utils.parseEther("10"), {
                        //so you instantiate the target contract and add paymaster params and bootloader knows how to handle this
                        // paymaster info

                        customData: {
                            paymasterParams: paymasterParams,
                            gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT
                        }
                    })
                )
                    // ).on("transactionHash", function (hash) {
                    //   handleTx("processing", hash)
                    // }).on("receipt", function (receipt) {
                    //   console.log(receipt)
                    //   if (receipt.status === true) {
                    //       setProcessingNFTMint(false)
                    //       handleTx("done", receipt.transactionHash)
                    //       toast.addSuccess(`NFT Successfully Minted`)
                    //   } else {
                    //       handleTx("error", receipt?.transactionHash)
                    //       toast.addError("Failed to Mint")
                    //       setProcessingNFTMint(false)
                    //   }
                    // })
                    .wait()
                    .then((receipt) => {
                        // console.log(receipt)
                        toast.addSuccess(`Tokens Successfully Minted`)
                    })
            } catch (error) {
                setProcessingTokenMint(false)
                console.log(error)
            }
        } else {
            toast.addInfo(`Select the zkSync Testnet network in your Metamask!`)
        }
        setProcessingTokenMint(false)
    }

    const mintNFTFunction = async () => {
        // const provider = new ethers.providers.Web3Provider(window.ethereum)
        const provider = new Provider("https://testnet.era.zksync.dev")
        const signer = new Web3Provider(window.ethereum).getSigner()
        const gasPrice = await provider.getGasPrice()
        if (chainId === 280) {
            setProcessingNFTMint(true)
            try {
                const erc721contract = new ethers.Contract(nftContract, nftAbi, signer)
                // const zkNFTcontract = new web3.eth.Contract(nftAbi, nftContract)
                const gasLimit = await erc721contract.estimateGas.mintNFT(wallet.account, companions.alyssa, {
                    //minting 5 tokens to the admin address
                    customData: {
                        gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT,
                        paymasterParams: paymasterParams
                    }
                })
                const fee = gasPrice.mul(gasLimit.toString())
                await (
                    await erc721contract.mintNFT(wallet.account, companions.alyssa, {
                        //so you instantiate the target contract and add paymaster params and bootloader knows how to handle this
                        // paymaster info

                        customData: {
                            paymasterParams: paymasterParams,
                            gasPerPubdata: utils.DEFAULT_GAS_PER_PUBDATA_LIMIT
                        }
                    })
                )
                    // ).on("transactionHash", function (hash) {
                    //   handleTx("processing", hash)
                    // }).on("receipt", function (receipt) {
                    //   console.log(receipt)
                    //   if (receipt.status === true) {
                    //       setProcessingNFTMint(false)
                    //       handleTx("done", receipt.transactionHash)
                    //       toast.addSuccess(`NFT Successfully Minted`)
                    //   } else {
                    //       handleTx("error", receipt?.transactionHash)
                    //       toast.addError("Failed to Mint")
                    //       setProcessingNFTMint(false)
                    //   }
                    // })
                    .wait()
                    .then((receipt) => {
                        // console.log(receipt)
                        toast.addSuccess(`NFT Successfully Minted`)
                    })
            } catch (error) {
                setProcessingNFTMint(false)
                console.log(error)
            }
        } else {
            toast.addInfo(`Select the zkSync Testnet network in your Metamask!`)
        }
        setProcessingNFTMint(false)
    }

    useEffect(() => {
        ;(async () => {
            setIsConnectedToWallet(wallet.status === "connected")
            if (wallet.account) {
                try {
                    setAccount(wallet.account)
                    setChainId(wallet.chainId)
                } catch (err) {
                    console.log(err)
                }
            }
        })()
    }, [wallet, wallet.account])

    return (
        <React.Fragment>
            <div className="content zkc-page">
                <BreadCrumb items={["zkCompanions"]} />
                {!isConnectedToWallet ? (
                    <ConnectWallet wallet={wallet} onChange={() => setIsConnectedToWallet(wallet.status === "connected")} />
                ) : (
                    <div className="zkc-body">
                        <Card>
                            <CardBody>
                                <CardTitle className="h3">Mint Your AI Companion</CardTitle>
                                <Button
                                    className="btn submit-btn w-100 blue-btn text-uppercase"
                                    onClick={() => handleSubmitButton("mintNFT")}
                                    style={{ width: "100%" }}
                                >
                                    {chainId !== 280
                                        ? `Change to zkSync Testnet in your wallet`
                                        : !processingNFTMint
                                          ? "Mint Companion NFT"
                                          : "Processing... "}
                                    {processingNFTMint ? <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" /> : null}
                                </Button>
                            </CardBody>
                        </Card>
                        <Card>
                            <CardBody>
                                <CardTitle className="h3">Mint ZKC Tokens</CardTitle>
                                <Button
                                    className="btn submit-btn w-100 blue-btn text-uppercase"
                                    onClick={() => handleSubmitButton("mintTokens")}
                                    style={{ width: "100%" }}
                                >
                                    {chainId !== 280
                                        ? `Change to zkSync Testnet in your wallet`
                                        : !processingTokenMint
                                          ? "Mint 10 Tokens"
                                          : "Processing... "}
                                    {processingTokenMint ? <Spinner style={{ width: "0.7rem", height: "0.7rem" }} color="light" /> : null}
                                </Button>
                            </CardBody>
                        </Card>
                        <Modal isOpen={txModal} fade={true} centered={true}>
                            <ModalHeader className="title-center">Transaction details</ModalHeader>
                            <ModalBody>
                                {tx.status === "processing"
                                    ? "Your transaction is being processed..."
                                    : tx.status === "done"
                                      ? "✅ Your transaction has been processed"
                                      : tx.status === "error"
                                        ? "❌ Your transaction failed"
                                        : "❓ No transaction information"}
                            </ModalBody>
                            <ModalBody>
                                <a href={"https://goerli.explorer.zksync.io/tx/" + tx.hash} target="_blank" rel="noopener noreferrer">
                                    View in explorer
                                </a>
                            </ModalBody>
                            <ModalFooter className="text-center">
                                <Button
                                    onClick={() => {
                                        handleTxModal("close")
                                    }}
                                >
                                    Close
                                </Button>
                            </ModalFooter>
                        </Modal>
                    </div>
                )}
            </div>
        </React.Fragment>
    )
}

export default ZkCompanions
